import { render, staticRenderFns } from "./myVouchers.vue?vue&type=template&id=227fc564&"
import script from "./myVouchers.vue?vue&type=script&lang=js&"
export * from "./myVouchers.vue?vue&type=script&lang=js&"
import style0 from "./myVouchers.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports